import { Typography } from '@mui/material';
import { InteractiveModal } from 'components/Modals/InteractiveModal/BaseModal';
import { useTranslation } from 'react-i18next';

export {};
interface Props {
  open: boolean;
  handleAbort: () => void;
  handleSuccess: () => void;
}

export const ConfirmClearNotificationModal = ({
  open,
  handleAbort,
  handleSuccess,
}: Props) => {
  const { t } = useTranslation();
  const title = 'Confirm Clear Notifications';

  return (
    <InteractiveModal
      initialState={open}
      title={title}
      handleAbort={handleAbort}
      SuccessButtonProps={{
        onClick: async () => {
          handleSuccess();
          handleAbort();
        },
        disabled: false,
        label: t('confirm_clear_notification'),
      }}
      ModalContentProps={{
        gridItemProps: {
          lg: 12,
        },
      }}
    >
      <Typography key="blurb-1" variant="medium">
        {t('are_you_sure_you_want_to_clear_the_notifications')}
      </Typography>
      <Typography key="blurb-2" variant="medium"></Typography>
    </InteractiveModal>
  );
};
